import { render, staticRenderFns } from "./ImgTemplate.vue?vue&type=template&id=73532638&scoped=true"
import script from "./ImgTemplate.vue?vue&type=script&lang=js"
export * from "./ImgTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73532638",
  null
  
)

export default component.exports